import { useDispatch } from 'react-redux';
import { ApiActionPayload } from '@interfaces/ApiAction/ApiActionPayload';
import { uploadDocumentSignedUrlAction } from '@data/documentSignedUrl/actionCreators/DocumentSignedUrlActionCreators';

export const useUploadDocumentWithSignedUrl = () => {
	const dispatch = useDispatch();

	return (signedUrl: string, file: File, docId: string, overrides: Partial<ApiActionPayload> = {}) => {
		dispatch(uploadDocumentSignedUrlAction(
			signedUrl,
			file,
			docId,
			overrides,
		));
	};
};
